import { isNullOrEmpty } from './utils';

const getPriorityAddress = (addresses) => addresses.find(address => address.priority === 1);

export const isValidAddress = (address) => address && !isNullOrEmpty(address.address1)
  && !isNullOrEmpty(address.firstName) && !isNullOrEmpty(address.lastName)
  && !isNullOrEmpty(address.zip) && !isNullOrEmpty(address.city)
  && !isNullOrEmpty(address.provinceCode);

/** US phone: 10 digits, optional leading +1 / 1 */
export const normalizeUsPhoneDigits = (phone) => {
  if (phone == null || typeof phone !== 'string') {
    return null;
  }
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return digits;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1);
  }
  return null;
};

export const isValidUsPhone = (phone) => normalizeUsPhoneDigits(phone) != null;

export default getPriorityAddress;
